import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-prompt-save-dialog',
    templateUrl: './prompt-save-dialog.component.html',
    styleUrls: ['./prompt-save-dialog.component.scss'],
    standalone: false
})
export class PromptSaveDialogComponent implements OnInit {

  value = '';

  fillControl = new UntypedFormControl('', [
    Validators.required
  ]);
  
  message;
  label;

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>) {
      this.message = this.data.message;
      this.label = this.data.lable;
   }

  ngOnInit() {
    if ( this.data != null && this.data.nome ){
      this.fillControl.setValue(this.data.nome);
    }
  }

  closeDialog(){
    this.dialogRef.close(false);
  }

  salvar(){
    if (!this.fillControl.valid) {
      this.fillControl.markAsTouched();
      return;
    }else{
      // o antigo template misturava [(ngModel)] com [formControl]; o nome vem do control
      this.data.nome = this.fillControl.value;
      this.dialogRef.close(this.data);
    }
  }
}
